import * as React from 'react';
import { PrimaryButton, DefaultButton, Link } from 'office-ui-fabric-react/lib/index';
import classnames from 'classnames'
import Wrapper, { DEFAULT_HELP_LINKS } from './Wrapper'
import { getVersion } from '../util';

export interface ProgressProps {
	error?: boolean;
	title: string;
	message: string;
	additional?: string;
	// Deep link into the help article for the error code in the message
	helpLink?: string;
	// Repeats the step that failed. Omitted when repeating cannot help, so
	// the button is not offered rather than sending the user in a circle.
	onRetry?: () => void;
	retryButtonTitle?: string;
	dismissButtonTitle?: string;
	onDismiss?: () => void;
	account?: any,
	autoLogin?: (any, string) => string,
	onSignout?: () => void,
	cancelButtonTitle?: string;
	continueButtonTitle?: string;
	onCancel?: () => void,
	onContinue?: () => void,
}

export default class Progress extends React.Component<ProgressProps> {

	private additionalRef = React.createRef<HTMLTextAreaElement>();

	// Support asks users to paste these details. Selecting them by hand in an
	// Outlook task pane is awkward, and the async Clipboard API is not
	// available in every Outlook webview, hence the execCommand fallback.
	private copyAdditional = () => {
		const textarea = this.additionalRef.current;
		if (!textarea) {
			return;
		}
		try {
			textarea.focus();
			textarea.select();
			document.execCommand('copy');
		} catch (ex) {
			try {
				(navigator as any).clipboard.writeText(textarea.value);
			} catch (clipboardEx) { /* leave the text selected for a manual copy */ }
		}
	}

	render() {
		const {
			error,
			title,
			message,
			additional,
			helpLink,
			onRetry,
			retryButtonTitle,
			dismissButtonTitle,
			cancelButtonTitle,
			continueButtonTitle,
			onCancel,
			onContinue,
			onDismiss,
			account,
			onSignout,
			autoLogin
		} = this.props;

		var finalMessage = message;

		var link = null;
		var linkLabel = 'More information in our FAQ';

		// indexOf returns -1 when the token is absent, and -1 is truthy: this
		// condition used to put the FAQ link under every message
		if (finalMessage.indexOf('##faq-multiplerecipients##') >= 0) {
			finalMessage = finalMessage.replace('##faq-multiplerecipients##', '');
			link = 'https://mm365.me/faq-multiplerecipients';
		}

		// A startup failure links straight to the section of the application
		// errors article for its code
		if (helpLink) {
			link = helpLink;
			linkLabel = 'What this error means and how to fix it';
		}

		return (
			<Wrapper
				account={account}
				autoLogin={autoLogin}
				onSignout={onSignout}
				className={classnames("mm-view mm-message", { "-error": error })}>
				<p className="ms-font-xl -title">{title}</p>
				<p className="ms-font-m -message">{finalMessage}</p>
				{link && <div className="" style={{ marginTop: "25px" }}>
					<ul className="-links">
						<li key={'more-info'}><i className="ms-Icon ms-Icon--ChevronRight" aria-hidden="true"></i>
							<Link target="_blank" href={link}>{linkLabel}</Link></li>
					</ul>
				</div>}


				{onRetry &&
					<p className="-button">
						<PrimaryButton onClick={() => onRetry()}>{retryButtonTitle || 'Try again'}</PrimaryButton>
					</p>}

				{onDismiss &&
					<p className="-button">
						<PrimaryButton onClick={() => onDismiss()}>{dismissButtonTitle || 'OK'}</PrimaryButton>
					</p>}



				{(onCancel || onContinue) &&
					<p className="-button">
						{onCancel &&
							<PrimaryButton onClick={() => onCancel()}>{cancelButtonTitle || 'Cancel'}</PrimaryButton>
						}
						{onContinue &&
							<DefaultButton onClick={() => onContinue()} style={{ marginLeft: '10px' }}>{continueButtonTitle || 'Continue'}</DefaultButton>
						}
					</p>
				}

				<small style={{ display: "block", paddingTop: "5px", paddingBottom: "5px" }}>Version: {getVersion()}</small>

				{additional && <div>
					<textarea
						ref={this.additionalRef}
						readOnly
						value={additional}
						aria-label="Technical details"
						style={{ fontSize: "10px", width: "100%", fontFamily: "monospace" }}
						rows={8} />
					<DefaultButton onClick={this.copyAdditional}>Copy technical details</DefaultButton>
				</div>}

			</Wrapper>
		);
	}
}
